import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Router, Switch} from "react-router-dom";
import {createBrowserHistory} from 'history';
import App from './app/PlayerApp';
import Guest from './app/Guest';
import './assets/scss/tema/Index.scss'
import './assets/scss/Index.scss'

//css
// import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-image-gallery/styles/css/image-gallery.css';
// import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'rc-rate/assets/index.css';
// flag icon
import 'flag-icon-css/sass/flag-icon.scss'
import './assets/css/font.css';
//  import '@fortawesome/fontawesome-pro/css/all.min.css';
import '@fortawesome/fontawesome-pro/css/all.css';
 import './assets/css/font.css';

  import './assets/googlefonts/fonts.css';  //import google fonts
 const currentPath = window.location.pathname;

// Assicurati che currentPath sia una stringa. Se non lo è, usa una stringa vuota
const safeCurrentPath = typeof currentPath === 'string' ? currentPath : '';

// Dividi il safeCurrentPath in segmenti basati su '/'
const pathSegments = safeCurrentPath.split('/');

// Inizializza firstSegment come una stringa vuota
let firstSegment = '';

// Se pathSegments ha elementi, ottieni il primo segmento significativo del path
if (pathSegments.length > 0) {
  // Ignora il primo elemento se è vuoto (accade se il path inizia con '/')
  firstSegment = pathSegments[0] === '' ? pathSegments[1] : pathSegments[0];
}

// Imposta basePath a '/guest' solo se il primo segmento significativo è 'guest'
const basePath = firstSegment === 'guest' ? '/guest' : '/player';

export const history = createBrowserHistory({ basename: basePath });

ReactDOM.render(
  <Router history={history}>
    {(basePath==="/guest") ? (
        <Switch>
          <Route  path="/" ><Guest/></Route>
        </Switch>
      ) : (
        <Switch>
          <Route  path="/" ><App /></Route>
        </Switch>
      )}
  </Router>,
  document.getElementById('root')
);
